// extracted by mini-css-extract-plugin
export default {"vip":"index_vip_p2Xh3"};